var EthereumQRPlugin = require('./lib').default

module.exports = EthereumQRPlugin
